import { AddCircleOutline as AddIcon } from '@mui/icons-material'
import { Box, IconButton, TextField, Toolbar, Tooltip, Typography } from '@mui/material'
import { debounce } from 'lodash-es'
import { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  handleAdd: (e: boolean) => void
  handleSearch: (value: string) => void
  title: string
  addButtonTooltip: string
  disableAddButton?: boolean
}
const TableToolbar = ({ handleAdd, handleSearch, title, addButtonTooltip, disableAddButton }: Props) => {
  const { t } = useTranslation()

  const debounceOnChange = useMemo(() => debounce(handleSearch, 300), [handleSearch])

  useEffect(() => {
    return () => {
      debounceOnChange.cancel()
    }
  })

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        mt: 1,
      }}
    >
      <Typography variant="h6" id="tableTitle" component="div">
        {title}
      </Typography>
      <TextField
        sx={{ ml: 2, mr: 2, minWidth: '30vh' }}
        label={t('common.search')}
        placeholder={t('common.searchEmailName')}
        onChange={(e) => debounceOnChange(e.target.value.toLowerCase())}
      />
      <Box sx={{ flex: '1 1 100%' }} />
      <Tooltip title={addButtonTooltip}>
        <IconButton onClick={() => handleAdd(true)} disabled={disableAddButton}>
          <AddIcon color={disableAddButton ? 'disabled' : 'primary'} />
        </IconButton>
      </Tooltip>
    </Toolbar>
  )
}

export default TableToolbar
